import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, SlidersHorizontalIcon } from 'lucide-react';
import { Button } from '../ui/Button';
interface FilterPanelProps {
  children: React.ReactNode;
  onReset?: () => void;
  className?: string;
}
export function FilterPanel({
  children,
  onReset,
  className = ''
}: FilterPanelProps) {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  return <>
      {/* Mobile Filter Button */}
      <div className="lg:hidden mb-4" data-id="element-109">
        <Button variant="outline" onClick={() => setIsMobileOpen(true)} leftIcon={<SlidersHorizontalIcon className="w-5 h-5" data-id="element-111" />} data-id="element-110">
          Фільтри
        </Button>
      </div>

      {/* Desktop Filters */}
      <aside className={`hidden lg:block ${className}`} data-id="element-112">
        <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-6" data-id="element-113">
          <div className="flex items-center justify-between mb-6" data-id="element-114">
            <h3 className="text-lg font-semibold text-white" data-id="element-115">Фільтри</h3>
            {onReset && <button onClick={onReset} className="text-sm text-blue-500 hover:text-blue-400 font-medium" data-id="element-116">
                Скинути
              </button>}
          </div>
          {children}
        </div>
      </aside>

      {/* Mobile Filter Drawer */}
      <AnimatePresence data-id="element-117">
        {isMobileOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 bg-black/70 z-40 lg:hidden" onClick={() => setIsMobileOpen(false)} data-id="element-118" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="fixed right-0 top-0 bottom-0 w-full max-w-sm bg-[#0a0a0a] z-50 lg:hidden overflow-y-auto border-l border-[#1a1a1a]" data-id="element-119">
              <div className="sticky top-0 bg-[#0a0a0a] border-b border-[#1a1a1a] p-4 flex items-center justify-between" data-id="element-120">
                <h3 className="text-lg font-semibold text-white" data-id="element-121">Фільтри</h3>
                <button onClick={() => setIsMobileOpen(false)} className="p-2 hover:bg-[#1a1a1a] rounded-lg transition-colors" aria-label="Закрити фільтри" data-id="element-122">
                  <XIcon className="w-6 h-6 text-gray-400" data-id="element-123" />
                </button>
              </div>
              <div className="p-4" data-id="element-124">{children}</div>
              <div className="sticky bottom-0 bg-[#0a0a0a] border-t border-[#1a1a1a] p-4 flex gap-3" data-id="element-125">
                {onReset && <Button variant="outline" onClick={onReset} className="flex-1" data-id="element-126">
                    Скинути
                  </Button>}
                <Button onClick={() => setIsMobileOpen(false)} className="flex-1" data-id="element-127">
                  Застосувати
                </Button>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}